import { useRef, useState, useCallback, useContext, useDebugValue, } from 'react';
import { useLayoutEffectWithoutSSRComplaining } from '@wix/da-hooks/pkg/useLayoutEffectWithoutSSRComplaining';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { DropdownDebugContext } from '../DropdownStateManager/DropdownStateContext';
export function useDropdownState(menuRef, toggleRef, _a) {
    var disabled = _a.disabled, openOnHover = _a.openOnHover, openBiData = _a.openBiData, onOpen = _a.onOpen, closeBiData = _a.closeBiData, onClose = _a.onClose, onToggle = _a.onToggle;
    var logBiEvent = useBiLogger();
    var forceOpen = useContext(DropdownDebugContext).forceOpen;
    var _b = useState(forceOpen), isOpen = _b[0], setIsOpen = _b[1];
    var wasOpen = useRef(false);
    var focusWasInDropdown = useRef(false);
    var openDropdown = useCallback(function () {
        if (isOpen || disabled) {
            return;
        }
        wasOpen.current = isOpen;
        focusWasInDropdown.current = false;
        setIsOpen(true);
        onOpen && onOpen();
        onToggle && onToggle(true);
        openBiData && logBiEvent(openBiData);
    }, [disabled, isOpen, onOpen, onToggle, logBiEvent, openBiData]);
    var closeDropdown = useCallback(function () {
        if (!isOpen || disabled || forceOpen) {
            return;
        }
        wasOpen.current = isOpen;
        focusWasInDropdown.current =
            !!menuRef.current && menuRef.current.contains(document.activeElement);
        setIsOpen(false);
        onClose && onClose();
        onToggle && onToggle(false);
        closeBiData && logBiEvent(closeBiData);
    }, [
        isOpen,
        disabled,
        forceOpen,
        menuRef,
        onClose,
        onToggle,
        closeBiData,
        logBiEvent,
    ]);
    var toggleDropdown = useCallback(function () {
        if (isOpen) {
            closeDropdown();
        }
        else {
            openDropdown();
        }
    }, [closeDropdown, isOpen, openDropdown]);
    // set focus after state change
    useLayoutEffectWithoutSSRComplaining(function () {
        if (isOpen && !wasOpen.current) {
            // focus menu
            if (menuRef.current) {
                menuRef.current.focus({ preventScroll: true });
            }
        }
        if (!isOpen && wasOpen.current) {
            // focus toggle
            if (focusWasInDropdown.current && toggleRef.current) {
                toggleRef.current.focus({ preventScroll: true });
            }
        }
    }, [isOpen]);
    useDebugValue(isOpen ? 'Open' : 'Closed');
    return { isOpen: isOpen, openOnHover: openOnHover, openDropdown: openDropdown, closeDropdown: closeDropdown, toggleDropdown: toggleDropdown };
}
//# sourceMappingURL=useDropdownState.js.map